import Vue from "vue/dist/vue.common";

import checkout from "./components/checkout";
import { createStore } from "./store";

export default class Checkout {
    init() {
        const store = createStore();

        new Vue({
            el: "#app",
            store,
            components: {
                checkout
            },
        });  
    }
}